const smoking = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "Sometimes", value: "Sometimes" },
  { label: "Chain smoker", value: "Chain smoker" },
];
export default smoking;
